<template>
    <div class="memwrap modulewrap">
        <Cmember :curnavkv="curnavkv" :subtitle="$common.dicword('mobileset')">
            <template v-if="isload">
                <div class="account">
                    <div class="mobiletop">
                        <ul>
                            <li :class="{cs:step==1}"><span>1</span>{{$common.dicword('verificationmember')}}<i></i></li>
                            <li><img src="/images/arrow.png" /></li>
                            <li :class="{cs:step==2}">
                                <span>2</span>{{$common.dicword('mobileset')}}<i></i>
                            </li>
                            <li><img src="/images/arrow.png" /></li>
                            <li :class="{cs:step==3}"><span>3</span>{{$common.dicword('setted')}}<i></i></li>
                        </ul>
                    </div>
                    <div class="mymobile" v-if="step==1">
                        <div class="mytip">
                            {{$common.dicword('mobileverification')}}({{$common.markmobile($store.state.mymobile)}})
                        </div>
                        <div class="myinput"><input type="text" v-model="mobile" class="txt" :placeholder="$common.dicword('currentmobile')" maxlength="50" /></div>
                        <div class="myinput2">
                            <input type="text" v-model="vcode" class="txt" :placeholder="$common.dicword('vcode')" maxlength="50" /><a href="#" class="btnsms" @click="getvcode">{{vcodetime>0?vcodetime:$common.dicword('sendcode')}}</a>
                        </div>
                        <div class="mybtn"><a href="#" @click="checkmobile">{{$common.dicword('ok')}}</a></div>
                    </div>
                    <div class="mymobile" v-if="step==2">
                        <div class="myinput"><input type="text" v-model="mobile" class="txt" :placeholder="$common.dicword('newmobile')" maxlength="50" /></div>
                        <div class="myinput2">
                            <input type="text" v-model="vcode" class="txt" :placeholder="$common.dicword('vcode')" maxlength="50" /><a href="#" class="btnsms" @click="getvcode">{{vcodetime>0?vcodetime:$common.dicword('sendcode')}}</a>
                        </div>
                        <div class="mybtn"><a href="#" @click="setmobile">{{$common.dicword('ok')}}</a></div>
                    </div>
                    <div class="mymobile" v-if="step==3">
                        <div class="mysuccess"><i class="iconfont icon-duigou"></i></div>
                        <div class="mytip">{{$common.dicword('mobilesaved')}} </div>
                    </div>
                </div>
            </template>
        </Cmember>
    </div>

</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'mobile',
        mixins: [mixinmember],
        data() {
            return {
                curnavkv: 8,
                mobile: '',
                vcode: '',
                vcodetime: 0,
                step: 1
            };
        },

        methods: {
            getdata: function () {
                this.step = this.$store.state.mymobile ? 1 : 2;
                this.isload = true;
            },
            checkmobile: function () {
                if (this.mobile && this.vcode) {
                    let jsondata = { 'postdata': { 'api': 'member', 'act': 'vcodechecksms', 'data': { 'mobile': this.mobile, 'vcode': this.vcode }, 'mobile': this.mobile } };
                    this.$common.post(jsondata, () => {
                        this.vcodetime = 0;
                        this.mobile = '';
                        this.vcode = '';
                        this.step = 2;
                    });
                }

            },
            setmobile: function () {
                if (this.mobile && this.vcode) {
                    let jsondata = {
                        'postdata': { 'api': 'member', 'act': 'mymobile2', 'data': { 'mobile': this.mobile, 'vcode': this.vcode }, 'mobile': this.mobile }
                    };
                    this.$common.post(jsondata, () => {
                        this.vcodetime = 0;
                        this.step = 3;
                    });
                }
            },
            getvcode: function () {

                let iserrmobile = this.mobile == '';
                if (!iserrmobile) {
                    iserrmobile = this.$common.validate(this.mobile, "ismobile") == -1;
                }
                else {
                    this.$common.alert('inputmobile');
                }
                if (!iserrmobile) {
                    let jsondata = {
                        'postdata': {
                            'api': 'member', 'act': 'vcodeget', "data": { "t": this.step == 1 ? 2 : 1 }, "mobile": this.mobile
                        }, 'msg': ''
                    };
                    this.$common.post(jsondata, () => {
                        this.vcodetime = 60;
                    });
                }
                else {
                    this.$common.alert('mobileerr');
                }
            }
        },
        mounted() {
            this.getdata();
            let vm = this;
            this.myinterval = window.setInterval(function () {
                if (vm.vcodetime > 0) {
                    vm.vcodetime--;
                }
            }, 1000);
        },
        beforeDestroy() {
            window.clearInterval(this.myinterval);
        }
    }

</script>
